var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-radio-box",attrs:{"data-box":_vm.box}},[_c('input',{attrs:{"id":_vm.id,"type":"radio","name":_vm.name,"data-text":_vm.dataText},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.onRadioClick}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id},domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }